module.exports = __webpack_public_path__ + "static/media/minus.7fcb2ca1.svg";